import { Link } from 'react-router-dom';
import { useState } from 'react';
import { slugify } from '../utils/slugify';

export default function ProductCard({ product }) {
  const [hovered, setHovered] = useState(false);
  const images = product.images?.filter(Boolean) || [];
  const img1 = images[0] || 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=600&q=80';
  const img2 = images[1] || null;
  const outOfStock = product.category === 'Bagues' && product.sizes?.length > 0
    ? Object.values(product.size_stock || {}).every(q => q === 0)
    : (product.stock_quantity ?? 0) === 0;

  return (
    <Link
      to={`/produit/${slugify(product.name)}`}
      style={{ textDecoration: 'none', color: '#111', display: 'block' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{
        overflow: 'hidden',
        aspectRatio: '1/1',
        marginBottom: '14px',
        background: '#f5f5f5',
        position: 'relative',
      }}>
        <img
          src={img1}
          alt={product.name}
          style={{
            width: '100%', height: '100%', objectFit: 'cover',
            transition: 'opacity 0.5s ease, transform 0.6s ease',
            transform: hovered ? 'scale(1.06)' : 'scale(1)',
            opacity: hovered && img2 ? 0 : 1,
            display: 'block',
          }}
        />
        {img2 && (
          <img
            src={img2}
            alt={product.name}
            style={{
              position: 'absolute', inset: 0,
              width: '100%', height: '100%', objectFit: 'cover',
              transition: 'opacity 0.5s ease, transform 0.6s ease',
              transform: hovered ? 'scale(1.06)' : 'scale(1)',
              opacity: hovered ? 1 : 0,
              display: 'block',
            }}
          />
        )}
        {outOfStock && (
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: '#111', padding: '10px 0', textAlign: 'center' }}>
            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '9px', letterSpacing: '3px', textTransform: 'uppercase', color: '#fff' }}>Épuisé</span>
          </div>
        )}
      </div>
      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '16px', fontWeight: 400, marginBottom: '4px',
        letterSpacing: '0.5px',
      }}>{product.name}</div>
      <div style={{
        fontFamily: "'Josefin Sans', sans-serif", fontWeight: 300,
        fontSize: '16px', letterSpacing: '1px'
      }}>
        Dh {Number(product.price).toFixed(2)} MAD
      </div>
    </Link>
  );
}
